import React from "react";
import TranslatedPage from "../../containers/TranslatedPage";
import PuzzleImage from "../../styles/images/white-monday-puzzle-image.jpg";
import GiftCardImage from "../../styles/images/white-monday-gift-card.jpg";

import "./WhiteMondayGiftCards.scss";
const WhiteMondayGiftCards = () => {
  return (
    <section className="white-monday-gift-cards large-padding gray-bg">
      <div className="main-container">
        <div className="content-wrapper">
          <h1 className="hero-heading how-it-works">
            <TranslatedPage path="whitemonday.content_blocks.whitemonday_gift_cards_header.heading" />
          </h1>
          <div className="gift-card-showcase">
            <div className="card-item">
              <div className="card-image"><img src={PuzzleImage} alt="ihopa puzzle" /></div>
              <div className="card-description">
                <h2><TranslatedPage path="whitemonday.content_blocks.whitemonday_gift_card1.heading" /></h2>
                <div className="card-copy"><TranslatedPage path="whitemonday.content_blocks.whitemonday_gift_card1.content" /></div>
              </div>
            </div>
            <div className="card-item">
              <div className="card-image"><img src={GiftCardImage} alt="ihopa gift card" /></div>
              <div className="card-description">
                <h2><TranslatedPage path="whitemonday.content_blocks.whitemonday_gift_card2.heading" /></h2>
                <div className="card-copy"><TranslatedPage path="whitemonday.content_blocks.whitemonday_gift_card2.content" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhiteMondayGiftCards;
